import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ScheduledCommand } from "../Model/ScheduledCommand";

export async function putScheduledCommand(id, data) {
	let response = await getAPIResponse("/command-scheduler/scheduled-command/" + id, data, "PUT");
	if (response === null) {
		return null;
	}
	let scheduledCommand = ScheduledCommand.createFromResponseData(response);
	return scheduledCommand;
}